<template lang="pug">
div.wrap-item-actor-photo-studio
  div(v-show="!vrmMainImg").wrap-studio
    div.wrap-canvas
      div(ref="wrapCanvas")

    div(v-if="!showObjectController"
      @click="showObjectController = true").wrap-toggle-object-controller.cursor-pointer
      v-icon(:color="pallete.$active_color" size="28" dark) mdi-wrap-disabled
    div(v-if="vrm && showObjectController").wrap-changer-window
      div.btn-hide.f.fh.py6
        v-icon(@click="showObjectController = false" dark) mdi-chevron-right
      div.wrap-tab-header.f
        div(v-for="tab in tabContents"
          @click="objectControllerTab = tab"
          :style="`width: ${100 / tabContents.length}%;`"
          :class="{'active': tab.name == objectControllerTab.name}").tab.f.fh.py8.cursor-pointer
          span.fz12 {{tab.label}}
      div(v-show="objectControllerTab.name == 'pose'").wrap-pose-changer
        ItemPoseChanger(ref="itemPoseChanger"
          :inUploader="inUploader"
          :vrm="vrm" :defaultAsset="defaultAsset"
          :transformControls="transformControls"
          :clock="clock"
          @updateBoneProp="updateBoneProp"
          @updateBlendShapeProp="updateBlendShapeProp")
      div(v-show="objectControllerTab.name == 'expression'").wrap-expression-changer
        ItemExpressionChanger(
          :isPhotoStudio="true"
          :targetObject="targetObject" :clock="clock"
          @updateEyesBoneProp="updateEyesBoneProp"
          @updateBlendShapeProp="updateBlendShapeProp"
          @addCustomTextureToVRM="addCustomTextureToVRM"
          @removeCustomTextureFromVRM="removeCustomTextureFromVRM")

    div(v-if="loadingProgress != 100").wrap-loading.f.fh.w-full.h-full.l0.t0
      div
        div.f.fc.mb8
          v-progress-circular(indeterminate)
        span.block.text-center.mb12 {{Math.floor(loadingProgress)}}%
        span.block.text-center.fz14 俳優の宣材写真を撮影しましょう！
    div(v-if="loadingProgress == 100" @click="onTakePhoto").btn.f.fm.px10.py8.cursor-pointer
      v-icon(v-if="!isUploading" dark).mr6 mdi-camera
      v-progress-circular(v-else indeterminate size="16" width="2" color="#fff").mr6
      span.fz14.bold 撮影する
  div(v-if="vrmMainImg").wrap-vrm-photo-img.w-full.h-full
    div(@click="onRetakePhoto").btn.f.fm.px10.py8.cursor-pointer
      v-icon(dark).mr6 mdi-camera-retake
      span.fz14.bold 取り直す
    div.f.fh.w-full.h-full
      img(:src="vrmMainImg").object-fit-cover.w-full.h-full
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$basic_margin: 12px;
$tab_height: 35px;
.wrap-item-actor-photo-studio {
  position: relative;
  width: 100%; height: 100%;
  .wrap-studio {
    position: relative;
    width: 100%; height: 100%;
    .wrap-toggle-object-controller {
      position: absolute;
      right: $basic_margin; top: $basic_margin;
    }
    .wrap-changer-window {
      position: absolute;
      width: 80vw; max-width: $studio_window_max_width;
      height: calc(100% - 16px);
      right: 8px; top: 8px;
      background: $overlay_color;
      border-radius: 3px 3px 3px 0;
      .btn-hide {
        position: absolute;
        width: 18px;
        left: -17px; top: 0px;
        background: $overlay_color;
        border-radius: 3px 0 0 3px;
      }
      .wrap-tab-header {
        .tab {
          color: $dark_primary_text_color;
          border-bottom: solid 0.8px $dark_primary_text_color;
          &.active {
            font-weight: bold;
            color: $active_color;
            border-bottom: solid 0.8px $active_color;
          }
        }
      }
      .wrap-pose-changer, .wrap-expression-changer {
        height: calc(100% - #{$tab_height});
      }
    }
    .wrap-loading {
      position: absolute;
    }
  }
  .wrap-vrm-photo-img {
    position: relative;
  }
  .btn {
    position: absolute;
    z-index: 10;
    top: 8px; left: 8px;
    background: $active_color;
    border-radius: 3px;
    span {
      color: $dark_primary_text_color;
    }
  }
}
</style>

<script>
import { blendShapes } from '@/plugins/vrm-nums'
import { storage } from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import studioManager from '@/components/mixin/studioManager'
import vrmManager from '@/components/mixin/vrmManager'
import gltfManager from '@/components/mixin/gltfManager'
import * as THREE from 'three'
import { VRMUtils } from '@pixiv/three-vrm'
// import { VRM, VRMSchema } from '@pixiv/three-vrm'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { TransformControls } from 'three/examples/jsm/controls/TransformControls'
import ItemPoseChanger from '@/components/item/studio/ItemPoseChanger'
import ItemExpressionChanger from '@/components/item/studio/ItemExpressionChanger'

export default {
  mixins: [studioManager, vrmManager, gltfManager],
  components: {
    ItemPoseChanger, ItemExpressionChanger
  },
  props: {
    vrmPath: {
      type: String,
      required: true
    },
    defaultAsset: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      renderer: null, scene: null, clock: null,
      camera: null,
      orbitControls: null,
      transformControls: null,
      updateByTranfromControlsTimer: null,
      targetObject: null,
      vrm: null, pose: null, blendShape: null,
      loadingProgress: 0,
      canvasSize: null,
      onResizeTimer: null,
      vrmMainImg: null,
      isUploading: false,
      objectControllerTab: { label: 'ポーズ', name: 'pose' },
      tabContents: [
        { label: 'ポーズ', name: 'pose' },
        { label: '表情 / 顔', name: 'expression' },
      ],
      showObjectController: true
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    inUploader () {
      const pagesIncludingUploader = ['edit-frame', 'user']
      return (this.defaultAsset || pagesIncludingUploader.includes(this.$route.name)) ? true : false
    },
    blendShapes () {
      return blendShapes
    }
  },
  watch: {
    objectControllerTab () {
      if (this.objectControllerTab.name === 'pose') {
        const itemPoseChanger = this.$refs.itemPoseChanger
        if (itemPoseChanger) itemPoseChanger.attachJointToTransformControls()
      } else {
        this.transformControls.detach()
      }
    }
  },
  async mounted () {
    window.addEventListener('resize', this.onResize)
    this.canvasSize = {
      width: this.$el.clientWidth,
      height: this.$el.clientHeight
    }

    await this.initializeScene()
    if (this.defaultAsset) this.vrmMainImg = this.defaultAsset.mainImg
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
    this.disposeScene({ renderer: this.renderer, scene: this.scene })
  },
  methods: {
    async initializeScene () {
      this.scene = new THREE.Scene()
      this.clock = new THREE.Clock()

      // レンダラーの設定
      this.renderer = this.createRenderer({ 
        size: { width: this.canvasSize.width, height: this.canvasSize.height }
      })
      this.$refs.wrapCanvas.appendChild(this.renderer.domElement)

      // カメラの設定
      this.camera = new THREE
        .PerspectiveCamera(35, this.canvasSize.width / this.canvasSize.height, 0.1, 1000)
      if (this.defaultAsset && this.defaultAsset.camera) {
        const vec3Pos = this.defaultAsset.camera.position
        this.camera.position.set(vec3Pos.x, vec3Pos.y, vec3Pos.z)
      } else {
        this.camera.position.set(0, 1.1, 3.5)
        // this.camera.position.set(0, 1.1, -2.5)
      }

      // PostProcessing
      this.initializeComposer({
        renderer: this.renderer, scene: this.scene, camera: this.camera
      })

      // カメラコントーロールの設定
      this.orbitControls = new OrbitControls(this.camera, this.renderer.domElement)
      // this.orbitControls.target.set(0, 1.0, 0)
      if (this.defaultAsset && this.defaultAsset.defaultOrbitControls) {
        const vec3Target = this.defaultAsset.defaultOrbitControls.target
        this.orbitControls.target0.set(vec3Target.x, vec3Target.y, vec3Target.z)
      } else {
        this.orbitControls.target.set(0, 1.0, 0)
      }
      this.orbitControls.screenSpacePanning = true
      this.orbitControls.update()

      // TransformControlsの設定
      this.transformControls = new TransformControls(this.camera, this.renderer.domElement)
      this.transformControls.addEventListener('mouseDown', (e) => {
          this.orbitControls.enablePan = false
          this.orbitControls.enableRotate = false
        }
      )
      this.transformControls.addEventListener('mouseUp', (e) => {
          this.orbitControls.enablePan = true
          this.orbitControls.enableRotate = true
        }
      )
      this.transformControls.addEventListener('objectChange', (e) => {
        if (this.updateByTranfromControlsTimer) clearTimeout(this.updateByTranfromControlsTimer)
        this.updateByTranfromControlsTimer = setTimeout(() => {
          const itemPoseChanger = this.$refs.itemPoseChanger
          if (itemPoseChanger && this.targetObject && this.targetObject.userData.vrm) {
            itemPoseChanger.updateBonePropByTransformControls()
          }
        }, 400)
        if (this.vrm) {
          const delta = this.clock.getDelta()
          this.vrm.update(delta)
        }
      })
      this.transformControls.traverse(node => node.layers.set(1))
      this.transformControls.getRaycaster().layers.set(1)
      const snapNum = 0.001

      this.transformControls.setRotationSnap(snapNum)
      this.scene.add(this.transformControls)

      // ライトの設定
      const light = new THREE.DirectionalLight(0xffffff)
      light.position.set(1, 10, 1).normalize()
      light.intensity = this.defaultDirectionalLightIntensity
      this.scene.add(light)

      const ambientLight = new THREE.AmbientLight(0xffffff)
      ambientLight.intensity = this.defaultAmbientLightIntensity * 0.6
      this.scene.add(ambientLight)
      
      // vrmのロード
      const progressFunc = (progress) => {
        this.loadingProgress = 100.0 * (progress.loaded / progress.total)
      }
      const errorFunc = (error) => {
        alert(error.type)
        console.error(error)
        this.$emit('closeModal')
      }
      const gltf = await this.loadGLTFwithDracoLoader({ 
        path: this.vrmPath, progressFunc, errorFunc
      })
      this.removeUnnecessaryElementsFromVRM({ gltf })

      this.vrm = gltf.userData.vrm
      // this.vrm = await VRM.from(gltf).then(vrm => vrm)

      this.registerCustomExpression(this.vrm)

      // materialのアウトラインなどの調整
      const delta = this.clock.getDelta()
      this.setOutlineToVRM({ 
        vrm: this.vrm,
        materials: gltf.userData.vrmMToonMaterials,
        delta,
        outlineWidth: 0.0015,
        // outlineWidth: { cloth: 0.002, hair: 0.001, skin: 0.003 },
        color: { r: 0, g: 0, b: 0, a: 0 }
      })

      this.vrm.scene.userData.vrm = this.vrm
      this.targetObject = this.vrm.scene

      if (this.isVRM1({ vrm: this.vrm })) {
        // this.vrm.scene.rotation.set(0, 3, 0)
      } else {
        this.vrm.scene.rotation.set(0, Math.PI, 0)
      }
      this.scene.add(this.vrm.scene)

      if (this.defaultAsset) {
        const asset = this.defaultAsset
        if (asset.photoBlendShape) {
          this.updateBlendShapeProp(asset.photoBlendShape)
          this.photoBlendShape = asset.photoBlendShape
        }
        if (asset.photoPose) {
          this.updateBoneProp(asset.photoPose)
          this.pose = this.getPose({ vrm: this.vrm })
        }
        if (asset.defaultOrbitControls) {
          const vec3Target = asset.defaultOrbitControls.target
          this.orbitControls.target.set(vec3Target.x, vec3Target.y, vec3Target.z)
          this.orbitControls.target0.set(vec3Target.x, vec3Target.y, vec3Target.z)
          this.orbitControls.screenSpacePanning = true
          this.orbitControls.update()
        }
      } else {
        const pose = JSON.parse(JSON.stringify(this.initialVrmPose))
        const delta = this.clock.getDelta()
        this.updatePose({ vrm: this.vrm, pose, delta })
        this.pose = this.getPose({ vrm: this.vrm })
        this.blendShape = this.blendShapes.map((blendShape, index) => {
          return { 
            ...blendShape,
            value: 0.0, 
            // index
          }
        })
      }
      // アニメーションを開始
      this.tick()
    },
    tick () {
      requestAnimationFrame(this.tick)

      // this.renderWithLayers(this.renderer)
      this.renderWithLayers({
        renderer: this.renderer, scene: this.scene, camera: this.camera
      })
      // this.composer.render(this.scene, this.camera)
      // this.renderer.render(this.scene, this.camera)
    },
    onResize () {
      if (this.onResizeTimer) clearTimeout(this.onResizeTimer)
      this.onResizeTimer = setTimeout(this.resizeCanvas, 400)
    },
    resizeCanvas () {
      this.canvasSize = {
        width: this.$el.clientWidth,
        height: this.$el.clientHeight
      }
      if (this.renderer && this.camera) {
        // カメラのアスペクト比を正す
        this.camera.aspect = this.canvasSize.width / this.canvasSize.height
        this.camera.updateProjectionMatrix()

        this.renderer.setPixelRatio(window.devicePixelRatio)
        this.renderer.setSize(this.canvasSize.width, this.canvasSize.height)
        this.resizeComposer({ 
          canvasSize: this.canvasSize, renderer: this.renderer
        })
        // this.resizeComposer(this.canvasSize)
      }
    },
    async onTakePhoto () {
      this.isUploading = true

      this.transformControls.detach()
      await this.sleep(100)

      try {
        const wrapCanvas = this.$refs.wrapCanvas
        const canvas = wrapCanvas.getElementsByTagName('canvas')[0]
        const base64 = canvas.toDataURL()
        const storageRef = storage.ref()
        const fileRef = storageRef.child(`/ASSET/${this.uid}/IMG/${this.getUniqueStr()}.png`)
        const downloadURL = await fileRef.putString(base64.split(',')[1], 'base64')
          .then(snapshot => {
            return snapshot.ref.getDownloadURL().then(downloadURL => downloadURL)
          })
        this.vrmMainImg = downloadURL
      } catch (error) {
        console.log(error)
      }

      const itemPoseChanger = this.$refs.itemPoseChanger
      if (itemPoseChanger) itemPoseChanger.attachJointToTransformControls()

      this.isUploading = false
    },
    onRetakePhoto () {
      this.vrmMainImg = null
    },
    getUniqueStr (myStrong) {
      let strong = 1000
      if (myStrong) strong = myStrong
      return new Date().getTime().toString(16)  + Math.floor(strong*Math.random()).toString(16)
    },
    updateBoneProp (pose) {
      if (!this.vrm) return
      const delta = this.clock.getDelta()
      this.updatePose({ vrm: this.vrm, pose, delta })
      this.pose = this.getPose({ vrm: this.vrm })
    },
    updateEyesBoneProp (pose) {
      if (!this.vrm) return
      const delta = this.clock.getDelta()
      this.updatePose({ vrm: this.vrm, pose, delta })
      this.pose = this.getPose({ vrm: this.vrm })
    },
    updateBlendShapeProp (blendShape) {
      if (!this.vrm) return
      const delta = this.clock.getDelta()
      this.updateBlendShape({ vrm: this.vrm, blendShape, delta })
      this.blendShape = blendShape
    },
    getCameraParams () {
      return {
        position: this.toPosition(this.camera.position),
        zoom: this.camera.zoom,
        fov: this.camera.fov
      }
    },
    getOrbitControlsParams () {
      return {
        position: this.toPosition(this.orbitControls.position0),
        target: this.toPosition(this.orbitControls.target)
      }
    }
  }
}
</script>
